import {Component, OnDestroy, OnInit} from "@angular/core";
import {DxModalOptions} from "../../domain/ui-options/dx-modal-options";
import {DxModalButton} from "../../domain/ui-options/dx-modal-button";
import {DxModalResult} from "../../domain/dx-modal-result";
import {DxModalResultType} from "../../domain/dx-modal-result-type";
import {SuiModal} from "ng2-semantic-ui";
import {DxModalContext} from "../../domain/dx-modal-context";
import {Observable, of} from "rxjs";
import {DxCoreUtils} from "../../../dx-core/utiles/dx-core-utils";


/** Базовый компонент модального окна. */
@Component({selector: 'dx-base-modal', template: ''})
export class DxBaseModalComponent implements OnInit, OnDestroy {
  /** Заголовок модального окна. */
  public title: string;
  /** Сообщение, отображаемое в теле модального окна. */
  public message: string;
  /** Опции модального окна. */
  protected _options: DxModalOptions;
  /** Массив кнопок модального окна. */
  protected _buttons: DxModalButton[];

  constructor(protected _modal: SuiModal<DxModalContext, DxModalResult, DxModalResult>) {
    this._buttons = [];
  }

  ngOnInit(): void {
    this._init();
  }

  ngOnDestroy(): void {
    this._destroy();
  }

  get options(): DxModalOptions {
    return this._options;
  }

  get buttons(): DxModalButton[] {
    return this._buttons;
  }
  
  public onCloseClick(): void {
    this._modal.deny(new DxModalResult(DxModalResultType.CANCEL));
  }

  public onFooterButtonClick(button: DxModalButton): void {
    if (button.handleCallback) {
      DxCoreUtils.toObservable(button.handleCallback()).subscribe(
        doNext => {
          if (doNext) {
            this.onFooterButtonClick2(button);
          }
        }
      );
    } else {
      this.onFooterButtonClick2(button);
    }
  }

  private onFooterButtonClick2(button: DxModalButton): void {
    switch (button.resultType) {
      case DxModalResultType.NONE:
        // do nothing here
        break;
      case DxModalResultType.OK:
        this._modal.approve(new DxModalResult(DxModalResultType.OK));
        break;
      case DxModalResultType.SAVE:
        this._handleSaveBtnClick();
        break;
      case DxModalResultType.CANCEL:
        this._modal.deny(new DxModalResult(DxModalResultType.CANCEL));
        break;
      default:
        this._modal.deny(new DxModalResult(DxModalResultType.CANCEL));
        break;
    }
  }

  protected _init(): void {
    // Наличие контекста и опций гарантируется на уровне сервиса.
    // Так как внешний вид ВСЕХ модалок в рамках одной системы должен быть единым.
    this._options = this._modal.context.options;
    if (this._options.buttons) {
      this._options.buttons.forEach(btn => this._buttons.push(btn));
    }
    this.title = this._modal.context.title ? this._modal.context.title : this._modal.context.options.title;
  }

  protected _destroy(): void {}

  protected _handleSaveBtnClick(): void {
    this._modal.approve(new DxModalResult(DxModalResultType.SAVE));
  }
}
